import React from "react";
import {
  FiUsers,
  FiShield,
  FiPlus,
  FiEye,
  FiClock,
  FiSettings,
} from "react-icons/fi";
import styles from "../css/shared.module.css";

const QuickAccessPanel = ({ onPanelSelect, activePanel }) => {
  const gptPanels = [
    {
      id: "gpt-management",
      title: "Gestión de GPTs",
      description: "Crear, editar y eliminar asistentes de IA",
      icon: FiSettings,
      color: "green",
    },
    {
      id: "gpt-access",
      title: "Acceso a GPTs",
      description: "Otorgar o revocar acceso de usuarios a GPTs específicos",
      icon: FiShield,
      color: "blue",
    },
  ];

  const userPanels = [
    {
      id: "user-management",
      title: "Gestión de Usuarios",
      description: "Crear usuarios y cambiar contraseñas",
      icon: FiUsers,
      color: "purple",
    },
    {
      id: "user-access",
      title: "Ver Accesos de Usuario",
      description: "Consultar y gestionar accesos de usuarios específicos",
      icon: FiEye,
      color: "indigo",
    },
    {
      id: "expiration-management",
      title: "Gestión de Expiraciones",
      description: "Administrar fechas de expiración de acceso",
      icon: FiClock,
      color: "red",
    },
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      blue: styles.quickAccessBlue,
      green: styles.quickAccessGreen,
      purple: styles.quickAccessPurple,
      orange: styles.quickAccessOrange,
      indigo: styles.quickAccessIndigo,
      red: styles.quickAccessRed,
    };
    return colorMap[color] || styles.quickAccessBlue;
  };

  return (
    <div className={styles.quickAccessContainer}>
      <h2 className={styles.quickAccessTitle}>Panel de Administración</h2>
      <p className={styles.quickAccessSubtitle}>
        Selecciona el panel que deseas gestionar
      </p>
      
      {/* Sección de GPTs */}
      <div className={styles.panelSection}>
        <h3 className={styles.sectionTitle}>
          <FiSettings className={styles.sectionIcon} />
          Gestión de GPTs
        </h3>
        <div className={styles.quickAccessGrid}>
          {gptPanels.map((panel) => {
            const IconComponent = panel.icon;
            const isActive = activePanel === panel.id;
            
            return (
              <button
                key={panel.id}
                className={`${styles.quickAccessCard} ${getColorClasses(panel.color)} ${
                  isActive ? styles.quickAccessCardActive : ""
                }`}
                onClick={() => onPanelSelect(panel.id)}
              >
                <div className={styles.quickAccessIcon}>
                  <IconComponent size={32} />
                </div>
                <div className={styles.quickAccessContent}>
                  <h3 className={styles.quickAccessCardTitle}>{panel.title}</h3>
                  <p className={styles.quickAccessDescription}>{panel.description}</p>
                </div>
                <div className={styles.quickAccessArrow}>
                  <FiPlus size={20} />
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Sección de Usuarios */}
      <div className={styles.panelSection}>
        <h3 className={styles.sectionTitle}>
          <FiUsers className={styles.sectionIcon} />
          Gestión de Usuarios
        </h3>
        <div className={styles.quickAccessGrid}>
          {userPanels.map((panel) => {
            const IconComponent = panel.icon;
            const isActive = activePanel === panel.id;
            
            return (
              <button
                key={panel.id}
                className={`${styles.quickAccessCard} ${getColorClasses(panel.color)} ${
                  isActive ? styles.quickAccessCardActive : ""
                }`}
                onClick={() => onPanelSelect(panel.id)}
              >
                <div className={styles.quickAccessIcon}>
                  <IconComponent size={32} />
                </div>
                <div className={styles.quickAccessContent}>
                  <h3 className={styles.quickAccessCardTitle}>{panel.title}</h3>
                  <p className={styles.quickAccessDescription}>{panel.description}</p>
                </div>
                <div className={styles.quickAccessArrow}>
                  <FiPlus size={20} />
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default QuickAccessPanel;